module.exports = __webpack_public_path__ + "img/goSetimg2.43ca7513.png";